exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tabular .tabluar-tabs li {\n  cursor: pointer; }\n\n.tabular .tabular-contents {\n  position: relative; }\n  .tabular .tabular-contents .tab-contents {\n    display: block;\n    overflow: hidden;\n    opacity: 0;\n    max-height: 999999px; }\n    .tabular .tabular-contents .tab-contents.current {\n      opacity: 1; }\n    .tabular .tabular-contents .tab-contents.hidden {\n      display: none; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/gui/tabular/tabular.scss
// module id = 175
// module chunks = 0